import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})

///Base Class for HTTP Abstraction
export class Dataservice {
  ///Base URL for HTTP requests
  private baseURL = "http://localhost:8080/";
  // private baseURL = window.location.origin;

  constructor(private httpClient: HttpClient) { }

  ///Abstraction for HTTP GET Request
  getRequest(requestURL: string, parameters?: {}) {
    ///Construct Request URL
    const apiURL = requestURL;

    ///Check For params
    if (parameters) {
      const requestParams = { params: parameters };
      return this.httpClient.get(apiURL, requestParams).toPromise();
    }

    return this.httpClient.get(apiURL).toPromise();
  }

  ///Abstraction for HTTP POST Request
  postRequest(requestURL: string, body: {}, parameters?: {}) {
    ///Construct Request URL
    const apiURL = requestURL;

    ///Check For params
    if (parameters) {
      const requestParams = { params: parameters };
      return this.httpClient.post(apiURL, body, requestParams).toPromise();
    }

    return this.httpClient.post(apiURL, body).toPromise();
  }

  ///Abstraction for HTTP PUT Request
  putRequest(requestURL: string, body: {}, parameters?: {}) {
    ///Construct Request URL
    const apiURL = requestURL;

    ///Check For params
    if (parameters) {
      const requestParams = { params: parameters };
      return this.httpClient.put(apiURL, body, requestParams).toPromise();
    }

    return this.httpClient.put(apiURL, body).toPromise();
  }

  ///Abstraction for HTTP DELETE Request
  deleteRequest(requestURL: string, body?: {}, parameters?: {}) {
    ///Construct Request URL
    const apiURL = requestURL;

    ///Check For params
    // if (parameters) {
    const requestParams = { params: parameters, body: body };
    return this.httpClient.delete(apiURL, requestParams).toPromise();
    // }

    // return this.httpClient.delete(apiURL, data).toPromise();
  }
}
